module.exports = {"130321100":"青龙镇","130321101":"祖山镇","130321102":"木头凳镇","130321103":"双山子镇","130321104":"马圈子镇","130321105":"肖营子镇","130321106":"大巫岚镇","130321107":"土门子镇","130321108":"八道河镇","130321109":"隔河头镇","130321110":"娄杖子镇","130321200":"凤凰山乡","130321201":"龙王庙乡","130321202":"三星口乡","130321203":"干沟乡","130321206":"大石岭乡","130321208":"官场乡","130321209":"茨榆山乡","130321210":"平方子乡","130321211":"安子岭乡","130321212":"朱杖子乡","130321213":"草碾乡","130321214":"七道河乡","130321217":"三拨子乡","130321218":"凉水河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130321.json
// module id = 96
// module chunks = 0